import { render } from "./DepartmentTree.vue?vue&type=template&id=783c9c5c&scoped=true"
import script from "./DepartmentTree.vue?vue&type=script&lang=js"
export * from "./DepartmentTree.vue?vue&type=script&lang=js"

import "./DepartmentTree.vue?vue&type=style&index=0&id=783c9c5c&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783c9c5c"]])

export default __exports__